import { render, staticRenderFns } from "./rep-quotations.vue?vue&type=template&id=3560cc1e&"
import script from "./rep-quotations.vue?vue&type=script&lang=js&"
export * from "./rep-quotations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports